module.exports = function capabilitiesFromHash({ supportsWebRTC }) {
  return {
    supportsWebRTC: supportsWebRTC === 'true' || supportsWebRTC === true,
  };
};
